import { render, staticRenderFns } from "./FpuiInputTextarea.vue?vue&type=template&id=4243bfe4&lang=pug&"
import script from "./FpuiInputTextarea.vue?vue&type=script&lang=js&"
export * from "./FpuiInputTextarea.vue?vue&type=script&lang=js&"
import style0 from "./FpuiInputTextarea.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports